<template>
  <div class="balance">
    {{ $t('balance') }}: {{ balance | currency }}
    <question-mark-popover
      class="popover"
      placement="bottomRight"
      :message="$t('balance.popover')"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import currency from '@/filters/currency';
import QuestionMarkPopover from '@/components/common/QuestionMarkPopover.vue';

export default {
  components: {
    QuestionMarkPopover,
  },
  filters: {
    currency,
  },
  computed: {
    ...mapGetters(['balance']),
  },
};
</script>

<style lang="scss" scoped>
.balance {
  font-weight: bold;
  font-size: 18px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.popover {
  margin: 0 5px;
}
</style>
